import { Component, EventEmitter, HostBinding, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { MatLegacyTableDataSource as MatTableDataSource } from '@angular/material/legacy-table';
import { Observable } from 'rxjs';
import { skip, tap } from 'rxjs/operators';

import { Sort } from '@angular/material/sort';
import { ICustomResponse } from '../../../../../../helpers/pipeable-operators.helper';
import { CutoutTypeEnum } from '../../../../../../models/cutting/cutting-panel-outline.model';
import { CuttingStandardCutout } from '../../../../../../models/cutting/cutting-standard-cutout.model';
import { CuttingPanelListService } from '../../../../cutting-panel-list.service';

@Component({
  selector: 'csl-standard-cutouts',
  templateUrl: './standard-cutouts.component.html',
  styleUrls: ['./standard-cutouts.component.scss'],
})
export class StandardCutoutsComponent implements OnChanges {
  @Input() groupId: number;
  @Input() panelHeight: number;
  @Input() panelWidth: number;

  thisCutoutTypeEnum = CutoutTypeEnum;

  dataSource: MatTableDataSource<CuttingStandardCutout> = new MatTableDataSource([]);
  displayedColumns = ['name', 'height', 'width', 'radius', 'type'];

  data$: Observable<ICustomResponse<CuttingStandardCutout[]>>;

  @Output() selectChanged: EventEmitter<CuttingStandardCutout> = new EventEmitter();

  @HostBinding('class.standard-cutout-list')
  standardCutoutList = true;

  constructor(private cuttingPanelListService: CuttingPanelListService) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes?.groupId?.currentValue) {
      this.data$ = this.cuttingPanelListService.getStandardCutouts(this.groupId).pipe(
        skip(1),
        tap(res => {
          this.dataSource.data = res.result;
        })
      );
    }
  }

  sortData(sort: Sort): void {
    this.data$ = this.cuttingPanelListService.getStandardCutouts(this.groupId, sort).pipe(
      tap(res => {
        this.dataSource.data = res.result;
      })
    );
  }
}
